/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionType from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';

const initialState = {
  dropdown: [],
  manufacturerList: [],
  errorMessagesInRedux: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_COMMON_DROPDOWN_DATA_CI:
      return { ...state, dropdown: action.dropdown };
    case actionType.GET_MANUFACTURER_GRID_LIST:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionType.SELECTION_TYPE_OPTIONS:
      return { ...state, selection_list: action.payload };
    case actionType.DROPDOWN_UPDATED_LIST:
      return { ...state, dropdownUpdatedList: action.payload };
    case actionType.HANDLE_ERROR_MESSAGE:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionType.GET_MAX_QUARTER:
      return { ...state, maximumQuarter: action.payload };
    case actionType.HEADER_INCONSISTENT_DETAILS:
      return { ...state, headerInconsistentData: action.payload };
    case actionType.FLAG_NAVIGATION:
      return { ...state, statusBit: action.payload };
    case actionType.SINGLE_INCONSISTENT_DATA:
      return { ...state, singleInconsistent: action.payload };
    case actionType.ROSI_MAIN_GRID:
      return { ...state, rosiMainGrid: action.payload };
    case actionType.PQAS_MAIN_GRID:
      return { ...state, pqasMainGrid: action.payload };
    case actionType.QUARTER_DATA_PQAS:
      return { ...state, quarterDataPqas: action.payload };
    case actionType.DETAIL_ROSI_DATA:
      return { ...state, detailRosiData: action.payload };
    case actionType.DETAIL_PQAS_DATA:
      return { ...state, detailPqasData: action.payload };
    case actionType.TAB_VALUE:
      return { ...state, tabValueStore: action.payload };
    case actionType.RESET_INCONSISTENCIES_DATA:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
